module.exports = __webpack_public_path__ + "img/logo.2a52146d.jpg";